import SouthProp from './SP';
import '../css/answers.css';

function AnswersList({
  parkType,
  waitList,
  campus,
  contact,
  storage,
  tel,
  eligibleGrp,
}) {
  // List of questions and answers to all campuses
  var CompList = [
    {
      id: 'div10',
      quest: 'Who is eligible for monthly parking?',
      answer: `Monthly parking is restricted to employees of NewYork-Presbyterian Hospital ${eligibleGrp}.`,
    },
    {
      id: 'div11',
      quest: 'What types of monthly parking are available?',
      answer: parkType,
    },

    {
      id: 'dive13',
      quest: 'How can I pay for monthly parking?',
      answer:
        'Pre-tax monthly parking dues can be collected via payroll deduction (recommended), or payment can be remitted on a monthly basis directly to the garage operator.',
    },
    {
      id: 'div1',
      quest:
        'How do I apply for a parking account, cancel my account, or update account information?',
      answer: (
        <ul>
          <li>
            <p style={{ marginBottom: -1 }}>
              Click{' '}
              <a href="https://app.smartsheet.com/b/form/481e30a27a234286a8d952537fba8e39">
                {' '}
                here
              </a>{' '}
              to access the online monthly application.
            </p>
          </li>
          <li>
            <p style={{ marginBottom: -1 }}>
              Click{' '}
              <a href="https://app.smartsheet.com/b/form/6fe537dde0794a30ac39536e0ccd3a5a">
                {' '}
                here
              </a>{' '}
              to access the online account cancellation application.
            </p>
          </li>
          <li>
            <p>
              Click{' '}
              <a href="https://app.smartsheet.com/b/form/3e25fe741ade4a9587749f1c9c87cdae">
                {' '}
                here
              </a>{' '}
              to access the online account information changes form.
            </p>
          </li>
        </ul>
      ),
    },
    {
      id: 'div2',
      quest: 'Is there a waitlist to be approved for monthly parking?',
      answer: waitList,
    },
    {
      id: 'div14',
      quest:
        'Who should I contact if I have questions about the application process?',
      answer: (
        <a href="mailto:" contact>
          Email us at {contact}
        </a>
      ),
    },
    {
      id: 'div15',
      quest:
        'I was notified that my ' +
        'application for monthly parking was approved. Can I start parking right away?',
      answer:
        'No. Refer to your approval notice email for further details. A prorated payment ' +
        'will be required before monthly access to the garage is allowed.' +
        'Please see your approval notice email for further details.',
    },
    {
      id: 'div16',
      quest: 'Can I have more than 1 vehicle associated with my account?',
      answer:
        'Yes. Each employee can register with up to 2 vehicles. ' +
        'However, only 1 vehicle may be parked at a time.',
    },
    {
      id: 'div17',
      quest: `Can I park in any garage on ${campus}?`,
      answer:
        'No. The Parking Department enforces a “1 Account, 1 Garage” policy.' +
        'Employees are only permitted to park in the garage to which they are assigned. ' +
        'Parking at another garage will incur transient rates.',
    },
    {
      id: 'div18',
      quest: 'Do I automatically have parking access at other NYP campuses?',
      answer:
        'No. You will need to apply separately to each campus. ' +
        'Please note that reciprocal parking access is not available ' +
        'on campuses with a waiting list.',
    },
    {
      id: 'div19',
      quest: 'Can I share my garage access?',
      answer:
        'No. The Parking Department enforces a “1 Employee, 1 Account” policy. ' +
        'Only the registered account owner is permitted to park using their access.',
    },
    {
      id: 'div20',
      quest: 'How do I update my personal or vehicle information?',
      answer: (
        <p>
          CLick{' '}
          <a href="https://app.smartsheet.com/b/form/3e25fe741ade4a9587749f1c9c87cdae">
            here
          </a>{' '}
          to access the Account Information Changes online form
        </p>
      ),
    },
    {
      id: 'div22',
      quest:
        'How should I notify the Parking Department of my leave of absence?',
      answer: (
        <p>
          PLease click{' '}
          <a href="https://app.smartsheet.com/b/form/6fe537dde0794a30ac39536e0ccd3a5a">
            here
          </a>{' '}
          and submit the form to notify the Parking Department of your leave of
          absence. If the Parking Department is not notified in writing of your
          leave status, your payroll deductions will continue, and no refunds
          will be issued.
        </p>
      ),
    },
    {
      id: 'div23',
      quest:
        'I have returned from a leave of absence and submitted the form. ' +
        'Can I start parking right away?',
      answer: (
        <p>
          No. You must compete and submit a monthly application form (click{' '}
          <a href="https://app.smartsheet.com/b/form/481e30a27a234286a8d952537fba8e39">
            here
          </a>{' '}
          to access the online form) and a prorated payment will be due before
          your monthly access to the garage can be reinstated. Please refer to
          your reinstatement notification email for more information.
        </p>
      ),
    },
    {
      id: 'div24',
      quest: 'How do I cancel my monthly parking account?',
      answer: (
        <p>
          Please click{' '}
          <a href="https://app.smartsheet.com/b/form/6fe537dde0794a30ac39536e0ccd3a5a">
            here
          </a>{' '}
          and submit the form to request cancellation of your account.
        </p>
      ),
    },
    {
      id: 'div25',
      quest:
        'I forgot to cancel my monthly account, ' +
        'but I stopped parking. Will I be able to get a refund?',
      answer: (
        <p>
          Cancellations are upon notification. If the Parking Department is not
          notified via the form (click{' '}
          <a href="https://app.smartsheet.com/b/form/6fe537dde0794a30ac39536e0ccd3a5a">
            here
          </a>{' '}
          to access the cancellation form), your payroll deductions will
          continue, and no refunds will be issued.
        </p>
      ),
    },
    {
      id: 'div26',
      quest: 'How far in advance should I request cancellation?',
      answer:
        'You must request cancellation at least 30 days in advance. ' +
        'Please be advised that Parking submits parking deduction reports seven ' +
        'days prior to the issuance of payroll checks. In order to prevent collections ' +
        'from taking place on a desired pay date, it is imperative that we receive the ' +
        'request prior to the payroll deduction report being sent to payroll.',
    },
    {
      id: 'div27',
      quest: 'Can I request cancellation on a specific date?',
      answer:
        'Cancellations must be requested for either the 15th or the last day of the month. ' +
        'We cannot prorate cancellations or offer partial refunds.',
    },
    {
      id: 'div3',
      quest: 'Can I have more than one car at the same time in the garage',
      answer:
        'No. Only 1 vehicle may be parked at a time. ' +
        'The parking access system will not permit multiple vehicles to be parked simultaneously.',
    },
    {
      id: 'div4',
      quest:
        'What if I lose my car identification tag or access card, ' +
        'change my car or the car identification tag stops working?',
      answer: (
        <p>
          Please contact the parking or the garage office to request a new tag.
          A fPlease contact the parking or garage office to request a
          replacement access card or tag. A fee may be imposed for lost
          access cards. You may also email us at{' '}
          <a href="mailto:" contact>
            {contact}
          </a>{' '}
          The garage office may be contacted at {tel}.
        </p>
      ),
    },
    {
      id: 'div5',
      quest: 'Can I remove the access tag and place on another car?',
      answer:
        'No, when the tag is peeled off, it will immediately stop working. Contact the parking office staff when you need to add a second car to your account or when you change your car',
    },
    {
      id: 'div6',
      quest: 'Can I store my car in the garage?',
      answer: storage,
    },

    {
      id: 'div7',
      quest:
        'Can I park my car if I live in buildings located in neighboring zip codes?',
      answer:
        'No. Employees who reside in buildings located in neighborhood zip codes are not allowed to park in NYP parking garages.',
    },
    {
      id: 'div8',
      quest: 'Do the garages accept SUVs and small vans?',
      answer:
        'Yes, but there is height restriction. Please remove all racks from your ' +
        'car’s roof before entering the garage. Please inquire with the parking ' +
        'location manager and the parking office staff regarding the additional cost ' +
        'and whether your vehicle can access the garage.',
    },
    {
      id: 'div9',
      quest: 'Do the garages accept shuttle size vans?',
      answer:
        'No. Large vans are not accepted due to height limits and parking space sizes.',
    },
  ];
  var MainList;
  return (MainList = CompList.map((targetDivs, divId) => (
    <div key={divId}>
      <SouthProp targetDivs={targetDivs} />
    </div>
  )));
}
export default AnswersList;
